import { Injectable } from '@angular/core';
import { HashMap, TranslocoMissingHandler, TranslocoMissingHandlerData } from '@ngneat/transloco';

/**
 * Custom handler for missing translations
 * Displays "..." for any missing translation key
 */
@Injectable({ providedIn: 'root' })
export class CustomTranslocoMissingHandler implements TranslocoMissingHandler {
    /**
     * Handle missing translation
     * 
     * @param key The missing translation key
     * @param data The missing handler data
     * @param params Optional parameters
     * @returns The placeholder string "..." to display instead of the key
     */
    handle(key: string, data: TranslocoMissingHandlerData, params?: HashMap): string {
        // Log missing translation in development mode
        console.warn(`Missing translation key: ${key}`);
        
        // Return "..." as placeholder for missing translations
        return '...';
    }
} 